export { LogoEditor } from './logo-editor'
